import React from 'react'
import ReactMarkdown from 'react-markdown'
import rehypePrism from 'rehype-prism-plus'
import 'prismjs/themes/prism-tomorrow.css'

export default function BlogRenderer({ content }) {
  return (
    <div className='prose prose-invert max-w-3xl mx-auto'>
      <ReactMarkdown rehypePlugins={[rehypePrism]}>{content}</ReactMarkdown>
    </div>
  )
}
